import { useState } from 'react';
import { Link } from 'react-router-dom';
import toast from 'react-hot-toast';
import api from '../services/api';
import { emailValidationMessage, normalizeEmail } from '../utils/emailValidation';

export default function ForgotPassword() {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    const msg = emailValidationMessage(email);
    if (msg) {
      toast.error(msg);
      return;
    }
    setLoading(true);
    try {
      await api.post('/api/auth/forgot-password', { email: normalizeEmail(email) });
      setSent(true);
    } catch (err) {
      toast.error(err?.message || 'Could not send reset email — try again shortly');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-slate-950 flex items-center justify-center p-4">
      <div className="w-full max-w-md bg-slate-900 border border-slate-800 rounded-2xl p-8">
        <Link to="/" className="block">
          <img src="/propscope-logo.png" alt="PropScope"
            className="h-24 w-auto object-contain mx-auto mb-2 hover:opacity-90 transition-opacity" />
        </Link>
        <h1 className="text-xl font-semibold text-white mb-2 text-center">Forgot password</h1>
        <p className="text-slate-500 text-sm text-center mb-6">
          Enter your email and we will send a reset link if an account exists.
        </p>

        {sent ? (
          <div className="text-center space-y-4">
            <p className="text-slate-300 text-sm">
              If <span className="text-white">{normalizeEmail(email)}</span> is registered,
              you will receive an email with a link to reset your password.
            </p>
            <Link to="/login" className="text-emerald-400 hover:underline text-sm">Back to sign in</Link>
          </div>
        ) : (
          <form onSubmit={handleSubmit} className="space-y-4">
            <div>
              <label htmlFor="forgot-email" className="block text-sm text-slate-400 mb-1">Email</label>
              <input
                id="forgot-email"
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                autoComplete="username"
                className="w-full bg-slate-800 border border-slate-700 rounded-lg px-3 py-2 text-white focus:outline-none focus:border-emerald-500"
              />
            </div>
            <button
              type="submit"
              disabled={loading}
              className="w-full bg-emerald-600 hover:bg-emerald-500 text-white rounded-lg py-2.5 font-medium transition-colors disabled:opacity-50"
            >
              {loading ? 'Sending...' : 'Send reset link'}
            </button>
          </form>
        )}

        <p className="text-center text-slate-500 text-sm mt-6">
          Remember your password? <Link to="/login" className="text-emerald-400 hover:underline">Sign in</Link>
        </p>
      </div>
    </div>
  );
}
